module.exports = __webpack_public_path__ + "media/src/img/uni/master-0340c00c9b8c41ad301e88d114cb48d9.svg";